import { useEffect, useState } from "react";
import Svg from "./figs/Svg";

export default function ModalPopup2({ content, isOpen, onClose }) {
  const [visible, setVisible] = useState(false);
  const [rendered, setRendered] = useState(false);

  useEffect(() => {
    if (isOpen) {
      setRendered(true);
      setTimeout(() => setVisible(true), 50);
    } else {
      setVisible(false);
      setTimeout(() => setRendered(false), 300);
    }
  }, [isOpen]);

  if (!rendered) return null;

  return (
    <div className="general_popup_container_2">
      <div
        className={`general_popup_2 transition-all duration-300 ${
          visible ? "open" : "close"
        }`}
      >
        <div className="general_popup_content">
          <span>{content}</span>
          <span onClick={onClose}>
            <Svg iconName="close" />
          </span>
        </div>
      </div>
    </div>
  );
}
